import gtag from '../gtag';
import { trackEvent } from './facebook';

export function trackCheckout(tripId: number, eventCategory: 'checkout' | 'instabook checkout'): void {
  gtag('event', 'Click to checkout', {
    event_category: eventCategory,
  });
  trackEvent('InitiateCheckout', { content_ids: [tripId] });
}

export function trackRegistration() {
  gtag('event', 'New Registration', {
    event_category: 'Authentication',
  });
  trackEvent('CompleteRegistration');
}

export type TrackPurchaseEventParams = {
  transactionId: number;
  bookingTotal: number;
  currency: string;
  locale: string;
  boatId: string;
  boatHeadline: string;
};
/**
 * Send the purchase event via Gtag GTM and onwards to Google Analytics
 * @param params Booking transaction details and locale
 */
export function trackPurchaseEvent({
  transactionId,
  bookingTotal,
  currency,
  locale,
  boatId,
  boatHeadline,
}: TrackPurchaseEventParams) {
  gtag('event', 'purchase', {
    transaction_id: transactionId,
    affiliation: 'GMB Booking',
    event_category: 'checkout',
    value: bookingTotal,
    currency,
    tax: 0,
    tax_rate: 0,
    shipping: 0,
    purchase_type: 'marketplace',
    locale,
    items: [{
      id: boatId,
      item_id: boatId,
      item_name: boatHeadline,
      quantity: 1,
      price: bookingTotal,
    }],
  });
}
